'use strict';

var RuleListingTransformerFactory = function RuleListingTransformerFactory(DataTransformer, momentService, UserProcessingTransformationService) {
  var DEFAULT_DISCONTINUE_END_DATE = momentService.of('2999-12-31', momentService.FIELD.RULE_DISCONTINUE_DATE);
  function RuleListingTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['rule-listing', 'rule-schedule-change-review', 'alert-rule-listing'];
    this.priority = 1;
  }
  RuleListingTransformer.prototype = Object.create(DataTransformer.prototype);
  RuleListingTransformer.constructor = RuleListingTransformer;
  RuleListingTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) !== -1;
  };
  RuleListingTransformer.prototype.isCacheable = function () {
    return true;
  };
  RuleListingTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function getDiscontinueDate(date, config) {
    var discontinueDate = momentService.of(date, config);
    if (discontinueDate && discontinueDate.isBefore(DEFAULT_DISCONTINUE_END_DATE)) {
      return discontinueDate;
    } else {
      return undefined;
    }
  }
  RuleListingTransformer.prototype.transform = function (data) {
    var rules = data && data.domain && data.domain.detailedRules || [];
    for (var i = 0; rules && i < rules.length; i++) {
      var rule = rules[i];
      rule.refStrategiesCount = rule.strategiesRef ? rule.strategiesRef.length : 0;
      rule.effectiveDate = momentService.of(rule.effectiveDate, momentService.FIELD.RULE_EFFECTIVE_DATE);
      rule.discontinueDate = getDiscontinueDate(rule.discontinueDate, momentService.FIELD.RULE_DISCONTINUE_DATE);
      rule.createdDate = momentService.of(rule.createdDate, momentService.FIELD.CREATED_DATE);
      rule.lastUpdatedAt = momentService.of(rule.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
      rule.eventTimeStamp = momentService.of(rule.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
      rule.isTrumpOverride = !!rule.isTrumpOverride;
      rule.isTrumpString = rule.isTrumpOverride ? 'Yes' : 'No';
      var strategies = rule.strategies;
      for (var j = 0; strategies && j < strategies.length; j++) {
        var strategy = strategies[j];
        strategy.createdDate = momentService.of(strategy.createdDate, momentService.FIELD.CREATED_DATE);
        strategy.eventTimeStamp = momentService.of(strategy.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        strategy.lastUpdatedAt = momentService.of(strategy.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
        strategy.lastUsedAt = momentService.of(strategy.lastUsedAt, momentService.FIELD.LAST_USED_AT);
        strategy.createdByDisplayName = UserProcessingTransformationService.getUserDisplayName(strategy.createdBy);
        strategy.lastUpdatedByDisplayName = UserProcessingTransformationService.getUserDisplayName(strategy.lastUpdatedBy);
      }
      rule.createdByDisplayName = UserProcessingTransformationService.getUserDisplayName(rule.createdBy);
      rule.lastUpdatedByDisplayName = UserProcessingTransformationService.getUserDisplayName(rule.lastUpdatedBy);
    }
    return rules;
  };
  return RuleListingTransformer;
};
RuleListingTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = RuleListingTransformerFactory;